import React from 'react';

type ISpaceItem = {
  onClick: () => void;
  text?: string;
  pronunciation: boolean;
};

const SpaceItem: React.FC<ISpaceItem> = ({ onClick, text, pronunciation }) => (
  <div style={{ display: 'inline' }} onClick={onClick}>
    {!pronunciation && text}{' '}
  </div>
);

export default SpaceItem;
